import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGraustrom = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Ebene_1",
	xmlns: "http://www.w3.org/2000/svg",
	width: 92.5,
	height: 90,
	viewBox: "0 0 200 200",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "#00488E",
		className: "cls-1",
		d: "M100,20c-47.85,0-80,32.15-80,80s32.15,80,80,80,80-32.15,80-80S147.85,20,100,20Zm50.84,130.84c-12.54,12.53-30.12,19.16-50.84,19.16s-38.3-6.63-50.84-19.16c-12.54-12.54-19.16-30.12-19.16-50.84s6.63-38.3,19.16-50.84c12.53-12.53,30.11-19.16,50.84-19.16s38.3,6.63,50.84,19.16c12.53,12.54,19.16,30.12,19.16,50.84s-6.63,38.3-19.16,50.84Z"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "#00488E",
		className: "cls-1",
		d: "M120.42,47.92l-6.99-3.63L53.7,110h28.34l-7.45,42.07,6.99,3.62,59.72-65.7h-28.34l7.45-42.08Zm-1.72,52.08l-30.72,33.79,5.98-33.79h-17.66l30.72-33.79-5.98,33.79h17.66Z"
	})]
});
export default SvgGraustrom;
